import { fork, all } from 'redux-saga/effects'
import { AddToWishlist } from '@sainsburys-tech/bolt'
import { watchGetContent } from './cms/getContent'
import { watchGetNoResultsContent } from './no-results/getNoResultsContent'
import { watchGetBrowseSeo } from './seo/getBrowseSeo'

export default function* rootSaga() {
  yield all([...AddToWishlist.sagas, fork(watchGetContent), fork(watchGetBrowseSeo), fork(watchGetNoResultsContent)])
}
